/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowADownRightIcon16Light } from './ArrowADownRightIcon16Light';
import { ArrowADownRightIcon16Regular } from './ArrowADownRightIcon16Regular';
import { ArrowADownRightIcon16Solid } from './ArrowADownRightIcon16Solid';
import { ArrowADownRightIcon20Light } from './ArrowADownRightIcon20Light';
import { ArrowADownRightIcon20Regular } from './ArrowADownRightIcon20Regular';
import { ArrowADownRightIcon20Solid } from './ArrowADownRightIcon20Solid';
import { ArrowADownRightIcon24Regular } from './ArrowADownRightIcon24Regular';
import { ArrowADownRightIcon24Solid } from './ArrowADownRightIcon24Solid';
import { ArrowADownRightIcon32Regular } from './ArrowADownRightIcon32Regular';
import { ArrowADownRightIcon64Regular } from './ArrowADownRightIcon64Regular';
var sizes = {
    16: {
        light: ArrowADownRightIcon16Light,
        regular: ArrowADownRightIcon16Regular,
        solid: ArrowADownRightIcon16Solid,
    },
    20: {
        light: ArrowADownRightIcon20Light,
        regular: ArrowADownRightIcon20Regular,
        solid: ArrowADownRightIcon20Solid,
    },
    24: {
        regular: ArrowADownRightIcon24Regular,
        solid: ArrowADownRightIcon24Solid,
    },
    32: {
        regular: ArrowADownRightIcon32Regular,
    },
    64: {
        regular: ArrowADownRightIcon64Regular,
    },
};
export var ArrowADownRightIcon = forwardRef('ArrowADownRightIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
